"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _PIMDataEntry2 = _interopRequireDefault(require("./PIMDataEntry"));

var _resolveColor = _interopRequireDefault(require("../utils/resolveColor"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DATA_KEY = {
  NAME: 'TitlePEP',
  STYLE: 'SubTitle',
  DESCRIPTION: 'DescriptionConsumer',
  DESIGNED_FOR: 'DesignedFor',
  RELEASE_DATE: 'PepReleaseDate',
  PRODUCT_BRAND: 'ProductBrand',
  PRODUCT_FAMILY: 'ProductFamily',
  TYPE: 'StyleCategory',
  BATTERY_LIFE: 'ExpectedBatteryLife',
  BATTERY_TYPE: 'BatterySize',
  HEARING_LOSS_TARGETS: 'HearingLossSeverity',
  IOS_VERSION: 'IosVersion',
  ANDROID_VERSION: 'AndroidVersion',
  COLORS: 'Variants',
  COLORS_HEX: 'ColorRGB',
  COLORS_NAME: 'ColorName',
  COLORS_KEY: 'ColorCode',
  COLOR_VARIANT_ID: 'VariantId',
  COLOR_IMAGE_URL: 'ImageUrl',
  CONFIGURATIONS: 'Configurations',
  IMAGES: 'Images',
  IMAGES_URL: 'ImageUrl',
  IMAGES_NAME: 'FileName',
  IMAGES_THUMBNAIL: 'ThumbnailUrl',
  IMAGES_TAGS: 'Tag',
  APPS: 'Apps',
  APPS_TITLE: 'Title',
  APPS_MARKETING_TITLE: 'Marketing Title - PEP',
  APPS_MARKETING_SUBTITLE: 'Marketing Subtitle - PEP',
  APPS_DESCRIPTION: 'Information',
  APPS_DESCRIPTION_SUB: 'Marketing Description - Consumer',
  APPS_IMAGES: 'Images',
  APPS_RESOURCES_LINK: 'ImageUrl',
  APPS_RESOURCES_LINK_THUMBNAIL: 'ThumbnailUrl',
  BENEFITS: 'Benefits',
  BENEFITS_TITLE: 'Title',
  BENEFITS_DESCRIPTION: 'DescriptionConsumer',
  BENEFITS_SECTION: 'Category',
  RECHARGEABILITY: 'Rechargeability',
  TELECOIL: 'Telecoil',
  BLUETOOTH: 'Bluetooth',
  PRODUCT_ID: 'ProductId',
  MARKETING_MATERIALS: 'MarketingMaterials',
  MARKETING_MATERIALS_URL: 'ImageUrl',
  MARKETING_MATERIALS_NAME: 'FileName',
  MARKETING_MATERIALS_TYPE: 'MarketingMaterialType',
  MARKETING_MATERIALS_LANGUAGES: 'Languages',
  MARKETING_MATERIALS_FACEPLATE_COLORS: 'FaceplateColors',
  MARKETING_MATERIALS_CUSTOM_SHELL_COLORS: 'CustomShellColors',
  ADDITIONAL_INFORMATION: 'AdditionalInformation',
  ADDITIONAL_INFORMATION_NEW: 'additionalInformation',
  ADDITIONAL_INFORMATION_TITLE: 'Title',
  LAUNCH_TAG: 'LaunchTag'
};

var PIMProduct = /*#__PURE__*/function (_PIMDataEntry) {
  _inherits(PIMProduct, _PIMDataEntry);

  var _super = _createSuper(PIMProduct);

  /**
   * @param {object} data
   * @constructor
   * @example
   * import { PIMProduct } from '@demant/pim';
   */
  function PIMProduct(data) {
    var _this;

    _classCallCheck(this, PIMProduct);

    _this = _super.call(this);
    /**
     * @type {number}
     */

    _this.productId = parseInt(_this.getString(data, DATA_KEY.PRODUCT_ID, -1), 10);
    /**
     * @type {string}
     */

    _this.name = _this.getString(data, DATA_KEY.NAME, '');
    /**
     * @type {string}
     */

    _this.style = _this.getString(data, DATA_KEY.STYLE, '');
    /**
     * @type {string}
     */

    _this.description = _this.getString(data, DATA_KEY.DESCRIPTION, '');
    /**
     * @type {string}
     */

    _this.releaseDate = _this.getString(data, DATA_KEY.RELEASE_DATE, '');
    /**
     * @type {string}
     */

    _this.productBrandAndFamily = "".concat(_this.getString(data, DATA_KEY.PRODUCT_BRAND, ''), " ").concat(_this.getString(data, DATA_KEY.PRODUCT_FAMILY, ''));
    /**
     * @type {string}
     */

    _this.productBrand = _this.getString(data, DATA_KEY.PRODUCT_BRAND, '');
    /**
     * @type {string}
     */

    _this.productFamily = _this.getString(data, DATA_KEY.PRODUCT_FAMILY, '');
    /**
     * @type {string}
     */

    _this.type = function () {
      var rawValue = _this.getString(data, DATA_KEY.TYPE, '');

      switch (rawValue) {
        case 'BCX':
        case 'BTE':
        case 'RITE':
          return 'BTE';

        case 'Custom':
          return 'ITE';

        default:
          return '';
      }
    }();
    /**
     * @type {string}
     */


    _this.styleCategory = _this.getString(data, DATA_KEY.TYPE, '');
    /**
     * @type {string[]}
     */

    _this.hearingLossTargets = _this.getArray(data, DATA_KEY.HEARING_LOSS_TARGETS, []);
    /**
     * @type {string[]}
     */

    _this.designedFor = _this.getArray(data, DATA_KEY.DESIGNED_FOR, []);
    /**
     * @type {string}
     */

    _this.iosVersion = _this.getString(data, DATA_KEY.IOS_VERSION, '');
    /**
     * @type {string}
     */

    _this.androidVersion = _this.getString(data, DATA_KEY.ANDROID_VERSION, '');
    /**
     * @type {boolean}
     */

    _this.isRechargeable = _this.getBooleanConfigurationValue(data, DATA_KEY.RECHARGEABILITY, DATA_KEY.CONFIGURATIONS);
    /**
     * @type {boolean}
     */

    _this.hasTelecoil = function () {
      var productValue = _this.getString(data, DATA_KEY.TELECOIL, '');

      if (productValue === true || productValue.toLowerCase() === 'yes' || productValue.toLowerCase() === 'true' || productValue === '1') {
        return true;
      }

      return _this.getBooleanConfigurationValue(data, DATA_KEY.TELECOIL, DATA_KEY.CONFIGURATIONS);
    }();
    /**
     * @type {boolean}
     */


    _this.hasBluetooth = function () {
      var productValue = _this.getString(data, DATA_KEY.BLUETOOTH, '');

      if (productValue === true || productValue.toLowerCase() === 'yes' || productValue.toLowerCase() === 'true' || productValue === '1') {
        return true;
      }

      return _this.getBooleanConfigurationValue(data, DATA_KEY.BLUETOOTH, DATA_KEY.CONFIGURATIONS);
    }();

    _this.bluetoothExcludesTelecoil = function () {
      var outputValue = false;

      if (_this.hasBluetooth && _this.hasTelecoil) {
        outputValue = true;

        var configurations = _this.getArray(data, DATA_KEY.CONFIGURATIONS, []);

        if (configurations.length === 0) {
          outputValue = false;
        }

        configurations.forEach(function (configuration) {
          var bluetoothValue = _this.getBoolean(configuration, DATA_KEY.BLUETOOTH, false);

          var telecoilValue = _this.getBoolean(configuration, DATA_KEY.TELECOIL, false);

          if (bluetoothValue && telecoilValue) {
            outputValue = false;
          }
        });
      }

      return outputValue;
    }();
    /**
     * @type {string[]}
     */


    _this.batteryType = function () {
      var outputValue = [];

      var productValue = _this.getString(data, DATA_KEY.BATTERY_TYPE, '');

      if (productValue !== '') {
        outputValue.push(productValue);
      }

      var configurations = _this.getArray(data, DATA_KEY.CONFIGURATIONS, []);

      configurations.forEach(function (configuration) {
        var configurationValue = _this.getString(configuration, DATA_KEY.BATTERY_TYPE, '');

        if (configurationValue !== '') {
          outputValue.push(configurationValue);
        }
      });
      return outputValue.filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
    }();
    /**
     * @type {number[]}
     */


    _this.batteryLifeRange = function () {
      var rawValues = _this.getArray(data, DATA_KEY.BATTERY_LIFE, []);

      var outputValues = [];
      rawValues.forEach(function (value) {
        var nValue = Number(value);

        if (!Number.isNaN(nValue)) {
          outputValues.push(nValue);
        }
      });
      return outputValues;
    }();
    /**
     * @type {PIMProductColor[]}
     */


    _this.colors = function () {
      var rawValues = _this.getArray(data, DATA_KEY.COLORS, []);

      var imagesWithColors = [];
      var outputValues = [];
      rawValues.forEach(function (value) {
        var colorNameForItem = _this.getString(value, DATA_KEY.COLORS_NAME, '');

        outputValues.push({
          hex: _this.getString(value, DATA_KEY.COLORS_HEX, ''),
          secondaryHex: _this.getString(value, DATA_KEY.COLORS_HEX, ''),
          name: colorNameForItem,
          secondaryName: colorNameForItem,
          key: _this.getString(value, DATA_KEY.COLORS_KEY, ''),
          secondaryKey: _this.getString(value, DATA_KEY.COLORS_KEY, ''),
          variantId: _this.getString(value, DATA_KEY.COLOR_VARIANT_ID, ''),
          images: function () {
            var outputImageValues = [];

            _this.getArray(value, DATA_KEY.IMAGES, []).forEach(function (imageValue) {
              var faceplateColors = _this.getArray(imageValue, DATA_KEY.MARKETING_MATERIALS_FACEPLATE_COLORS, []);

              if (faceplateColors.length && faceplateColors[0] !== colorNameForItem) {
                imagesWithColors.push(imageValue);
                return;
              }

              var customShellColors = _this.getArray(imageValue, DATA_KEY.MARKETING_MATERIALS_CUSTOM_SHELL_COLORS, []);

              if (customShellColors.length && customShellColors[0] !== colorNameForItem) {
                imagesWithColors.push(imageValue);
                return;
              }

              outputImageValues.push({
                url: _this.getString(imageValue, DATA_KEY.IMAGES_URL),
                name: _this.getString(imageValue, DATA_KEY.IMAGES_NAME),
                thumbnail: _this.getString(imageValue, DATA_KEY.IMAGES_THUMBNAIL)
              });
            });

            return outputImageValues;
          }()
        });
      }); // SEARCH FOR COLORS IN PRODUCT IMAGES.

      var productImages = _this.getArray(data, DATA_KEY.IMAGES, []);

      productImages.forEach(function (productImage) {
        var faceplateColors = _this.getArray(productImage, DATA_KEY.MARKETING_MATERIALS_FACEPLATE_COLORS, []);

        var customShellColors = _this.getArray(productImage, DATA_KEY.MARKETING_MATERIALS_CUSTOM_SHELL_COLORS, []);

        if (faceplateColors.length || customShellColors.length) {
          imagesWithColors.push(productImage);
        }
      });
      imagesWithColors.forEach(function (imageWithColor) {
        var faceplateColors = _this.getArray(imageWithColor, DATA_KEY.MARKETING_MATERIALS_FACEPLATE_COLORS, []);

        var customShellColors = _this.getArray(imageWithColor, DATA_KEY.MARKETING_MATERIALS_CUSTOM_SHELL_COLORS, []);

        var hex = customShellColors.length ? (0, _resolveColor["default"])(customShellColors[0]) : null;
        var secondaryHex = faceplateColors.length ? (0, _resolveColor["default"])(faceplateColors[0]) : null;

        if (hex && secondaryHex) {
          var existingColor = outputValues.find(function (colorValue) {
            return colorValue.hex === hex && colorValue.secondaryHex === secondaryHex;
          });

          if (existingColor) {
            existingColor.images.push({
              url: _this.getString(imageWithColor, DATA_KEY.IMAGES_URL),
              name: _this.getString(imageWithColor, DATA_KEY.IMAGES_NAME),
              thumbnail: _this.getString(imageWithColor, DATA_KEY.IMAGES_THUMBNAIL)
            });
          } else {
            outputValues.push({
              hex: hex,
              secondaryHex: secondaryHex,
              name: customShellColors.length ? customShellColors[0] : null,
              secondaryName: faceplateColors.length ? faceplateColors[0] : null,
              key: null,
              secondaryKey: null,
              variantId: -1,
              images: [{
                url: _this.getString(imageWithColor, DATA_KEY.IMAGES_URL),
                name: _this.getString(imageWithColor, DATA_KEY.IMAGES_NAME),
                thumbnail: _this.getString(imageWithColor, DATA_KEY.IMAGES_THUMBNAIL)
              }]
            });
          }
        }
      });
      imagesWithColors.forEach(function (imageWithColor) {
        var faceplateColors = _this.getArray(imageWithColor, DATA_KEY.MARKETING_MATERIALS_FACEPLATE_COLORS, []);

        var customShellColors = _this.getArray(imageWithColor, DATA_KEY.MARKETING_MATERIALS_CUSTOM_SHELL_COLORS, []);

        var hex = customShellColors.length ? (0, _resolveColor["default"])(customShellColors[0]) : null;
        var secondaryHex = faceplateColors.length ? (0, _resolveColor["default"])(faceplateColors[0]) : null;

        if (hex && !secondaryHex || !hex && secondaryHex) {
          outputValues.forEach(function (colorValue) {
            if (colorValue.hex === hex || colorValue.secondaryHex === secondaryHex) {
              colorValue.images.push({
                url: _this.getString(imageWithColor, DATA_KEY.IMAGES_URL),
                name: _this.getString(imageWithColor, DATA_KEY.IMAGES_NAME),
                thumbnail: _this.getString(imageWithColor, DATA_KEY.IMAGES_THUMBNAIL)
              });
            }
          });
        }
      });
      return outputValues.filter(function (colorData) {
        return colorData.images.length > 0;
      });
    }();
    /**
     * @type {PIMProductImage[]}
     */


    _this.images = function () {
      var rawValues = _this.getArray(data, DATA_KEY.IMAGES, []);

      var outputValues = [];
      rawValues.forEach(function (value, index) {
        var faceplateColors = _this.getArray(value, DATA_KEY.MARKETING_MATERIALS_FACEPLATE_COLORS, []);

        var customShellColors = _this.getArray(value, DATA_KEY.MARKETING_MATERIALS_CUSTOM_SHELL_COLORS, []);

        if (index === 0 || faceplateColors.length === 0 || customShellColors.length === 0) {
          outputValues.push({
            url: _this.getString(value, DATA_KEY.IMAGES_URL),
            name: _this.getString(value, DATA_KEY.IMAGES_NAME),
            thumbnail: _this.getString(value, DATA_KEY.IMAGES_THUMBNAIL)
          });
        }
      });

      var rawColors = _this.getArray(data, DATA_KEY.COLORS, []);

      rawColors.forEach(function (value) {
        var color = _this.getString(value, DATA_KEY.COLORS_HEX, '');

        if (!color) {
          _this.getArray(value, DATA_KEY.IMAGES, []).forEach(function (imageValue) {
            outputValues.push({
              url: _this.getString(imageValue, DATA_KEY.IMAGES_URL),
              name: _this.getString(imageValue, DATA_KEY.IMAGES_NAME),
              thumbnail: _this.getString(imageValue, DATA_KEY.IMAGES_THUMBNAIL)
            });
          });
        }
      });
      return outputValues;
    }();
    /**
     * @type {PIMProductBenefit[]}
     */


    _this.benefits = function () {
      var rawValues = _this.getArray(data, DATA_KEY.BENEFITS, []);

      var outputValues = [];
      rawValues.forEach(function (value) {
        outputValues.push({
          title: _this.getString(value, DATA_KEY.BENEFITS_TITLE, ''),
          description: _this.getString(value, DATA_KEY.BENEFITS_DESCRIPTION, ''),
          section: _this.getString(value, DATA_KEY.BENEFITS_SECTION, '')
        });
      });
      return outputValues;
    }();
    /**
     * @type {PIMProductApp[]}
     */


    _this.apps = function () {
      var rawValues = _this.getArray(data, DATA_KEY.APPS, []);

      var outputValues = [];
      rawValues.forEach(function (value) {
        outputValues.push({
          title: _this.getString(value, DATA_KEY.APPS_TITLE, ''),
          description: _this.getString(_this.getRaw(value, DATA_KEY.APPS_DESCRIPTION, {}), DATA_KEY.APPS_DESCRIPTION_SUB, ''),
          marketingTitle: _this.getString(_this.getRaw(value, DATA_KEY.APPS_DESCRIPTION, {}), DATA_KEY.APPS_MARKETING_TITLE, ''),
          marketingSubTitle: _this.getString(_this.getRaw(value, DATA_KEY.APPS_DESCRIPTION, {}), DATA_KEY.APPS_MARKETING_SUBTITLE, ''),
          images: function () {
            var imageOutputValues = [];

            _this.getArray(value, DATA_KEY.APPS_IMAGES, []).forEach(function (imageValue) {
              imageOutputValues.push({
                url: _this.getString(imageValue, DATA_KEY.APPS_RESOURCES_LINK),
                thumbnail: _this.getString(imageValue, DATA_KEY.APPS_RESOURCES_LINK_THUMBNAIL)
              });
            });

            return imageOutputValues;
          }()
        });
      });
      return outputValues;
    }();
    /**
     * @type {PIMMarketingMaterial[]}
     */


    _this.marketingMaterials = function () {
      var rawValues = _this.getArray(data, DATA_KEY.MARKETING_MATERIALS, []);

      var outputValues = [];
      rawValues.forEach(function (value) {
        outputValues.push({
          url: _this.getString(value, DATA_KEY.MARKETING_MATERIALS_URL, ''),
          name: _this.getString(value, DATA_KEY.MARKETING_MATERIALS_NAME, ''),
          marketingMaterialType: _this.getString(value, DATA_KEY.MARKETING_MATERIALS_TYPE, ''),
          languages: _this.getArray(value, DATA_KEY.MARKETING_MATERIALS_LANGUAGES, []),
          launchTag: _this.getString(value, DATA_KEY.LAUNCH_TAG, '')
        });
      });
      return outputValues;
    }();
    /**
     * @type {Object.<string, PIMMarketingMaterial[]>}
     */


    _this.additionalInformation = function () {
      var rawValues = _this.getArray(data, DATA_KEY.ADDITIONAL_INFORMATION, []);

      var outputValues = {};
      rawValues.forEach(function (value) {
        var title = _this.getString(value, DATA_KEY.ADDITIONAL_INFORMATION_TITLE, '');

        outputValues[title] = [];

        var marketingMaterials = _this.getArray(value, DATA_KEY.MARKETING_MATERIALS, []);

        marketingMaterials.forEach(function (subValue) {
          outputValues[title].push({
            url: _this.getString(subValue, DATA_KEY.MARKETING_MATERIALS_URL, ''),
            name: _this.getString(subValue, DATA_KEY.MARKETING_MATERIALS_NAME, ''),
            marketingMaterialType: _this.getString(subValue, DATA_KEY.MARKETING_MATERIALS_TYPE, ''),
            languages: _this.getArray(subValue, DATA_KEY.MARKETING_MATERIALS_LANGUAGES, []),
            launchTag: _this.getString(value, DATA_KEY.LAUNCH_TAG, '')
          });
        });
      });
      return outputValues;
    }();
    /**
     * @type {PIMProduct[]}
     */


    _this.relatedAccessories = [];
    return _this;
  }

  return PIMProduct;
}(_PIMDataEntry2["default"]);

var _default = PIMProduct;
/**
 * @typedef PIMProductColor
 * @property {string} hex
 * @property {string} name
 * @property {string} key
 * @property {string} variantId
 * @property {PIMProductImage[]} images
 * */

/**
 * @typedef PIMProductImage
 * @property {string} url
 * @property {string} name
 * @property {string} thumbnail
 * */

/**
 * @typedef PIMProductBenefit
 * @property {string} title
 * @property {string} description
 * @property {string} section
 * */

/**
 * @typedef PIMProductApp
 * @property {string} title
 * @property {string} description
 * @property {PIMProductAppResource[]} resources
 */

/**
 * @typedef PIMProductAppResource
 * @property {string} url
 */

/**
 * @typedef PIMMarketingMaterial
 * @property {string} url
 * @property {string} name
 */

exports["default"] = _default;